<template>
  <div class="hospitalFrame">
    <div style="font-size: 4rem">{{user.userType == 5 ? '渔业局' : '执法大队'}} </div>

    <van-row
      class="grid-title"
      style="width:80vw;margin-top: 3em;"
    >
      <van-cell>
        <template #title>
          <van-row>
            <van-col span="4">发起人</van-col>
            <van-col span="4">发起时间</van-col>
            <van-col span="4">接收人</van-col>
            <van-col span="4">状态</van-col>
            <van-col span="4">结束时间</van-col>
            <van-col span="4">操作</van-col>
          </van-row>
        </template>
      </van-cell>
    </van-row>
    <van-empty
      style="background-color: #ffffff;width:80vw;"
      v-if="!loading && data.length===0"
      description="没有数据"
    />
    <van-list style="width:80vw;">
      <van-cell
        v-for="(item,index) in data"
        :key="item.id"
      >
        <template #title>
          <van-row>
            <van-col
              span="4"
              class="c-cell"
            >{{item.userName}}</van-col>
            <van-col
              span="4"
              class="c-cell"
            >{{item.callTime}}</van-col>
            <van-col
              span="4"
              class="c-cell"
            >{{item.receiver}}</van-col>
            <van-col
              span="4"
              class="c-cell"
            >
              <van-tag
                v-if="item.picked===1"
                type="success"
              >{{item.pickedName}}</van-tag>
              <van-tag
                v-if="item.picked===0"
                type="warning"
              >{{item.pickedName}}</van-tag>
            </van-col>
            <van-col
              span="4"
              class="c-cell"
            >{{item.endTime}}</van-col>
            <van-col
              span="4"
              class="c-cell"
            >
              <van-row style="width: 100%;">
                <van-col
                  span="12"
                  style="padding:0px 8px;text-align: center;"
                >
                  <van-button
                    type="info"
                    size="small"
                    @click="join(item.room_id)"
                    v-show="item.picked===1 && !item.endTime"
                  >进入房间</van-button>
                </van-col>
                <van-col
                  span="12"
                  style="padding:0px 8px;text-align: center;"
                  v-if=" user.userType == 5"
                >
                  <van-button
                    type="warning"
                    size="small"
                    style="width:100%"
                    v-if="item.do1 === 0"
                    @click="do1(index,item.id)"
                  >申请出警</van-button>
                  <span v-if="item.do1 === 1 && item.do2===0">已申请出警</span>
                  <span v-if="item.do1 === 1 && item.do2===1">已安排出警</span>
                  <span v-if="item.do1 === 1 && item.do2===2">不需要出警</span>
                </van-col>

                <van-col
                  span="12"
                  style="padding:0px 8px;text-align: center;"
                  v-if=" user.userType == 6"
                >
                  <van-button
                    type="primary"
                    size="small"
                    style="width:100%"
                    v-if="item.do1 === 1 && item.do2!==1"
                    @click="do2(index,item.id,1)"
                  >安排</van-button>
                  <van-button
                    type="danger"
                    size="small"
                    style="width:100%"
                    v-if="item.do1 === 1 && item.do2!==2"
                    @click="do2(index,item.id,2)"
                  >不用</van-button>
                  <span v-if="item.do1 === 1 && item.do2===1">已安排出警</span>
                  <span v-if="item.do1 === 1 && item.do2===2">不需要出警</span>
                </van-col>
              </van-row>

            </van-col>
          </van-row>
        </template>
      </van-cell>
    </van-list>
    <van-row style="width:80vw;">
      <van-cell>
        <template #title>
          <van-row>
            <van-col
              span="24"
              style="text-align: center;"
            >
              <span
                v-if="finished"
                style="color:rgba(0, 0, 0, 0.45);"
              >没有更多了</span>
              <van-loading
                type="spinner"
                v-if="loading"
              />
              <a
                v-if="!loading && !finished && data.length > 0"
                href="#"
                @click="pageNext()"
              >加载更多({{ data.length +'/' + dataCount }})
              </a>
            </van-col>
          </van-row>
        </template>
      </van-cell>
    </van-row>

    <van-button
      style="font-size: 1rem;height:2rem;position: absolute; top:16px;right: 16px;"
      type="danger"
      @click="loginout()"
    >退出登录</van-button>
  </div>
</template>

<script>
import util from '@/api/util.js';
import server from '@/api/hospital.js';
export default {
  data () {
    return {
      loading: false,
      finished: false,
      data: [],
      dataCount: 0,
      user: {},
      q: {
        PageIndex: 0,
        PageSize: 10,
        isPage: true,
        userName: "",
        DateStart: "",
        DateEnd: "",
      }
    }
  },
  created () {
    this.user = util.userData() || {}
    this.data = []
    this.q.PageIndex = 0
    this.getData()
  },
  // 生命周期 - 销毁完成
  destroyed () {
    // clearRem()
  },
  methods: {
    pageNext () {
      this.q.PageIndex = this.q.PageIndex + 1
      this.getData()
    },
    getData () {
      this.loading = true
      server.getRecords(this.q).then(res => {
        res.data.forEach(item => {
          item.pickedName = item.picked === 1 ? "已接听" : "未接听";
          this.data.push(item)
        });
        this.dataCount = res.dataCount
        if (this.data.length >= res.dataCount) {
          this.finished = true
        }
        this.loading = false
        this.$forceUpdate()
        this.forGetData()
      })
    },
    forGetData () {
      window.setTimeout(() => {
        const param = { ...this.q }
        param.PageIndex = 0;
        param.PageSize = 10;
        server.getRecords(param).then(res => {
          if (res.isSuccess) {
            for (let i = res.data.length - 1; i >= 0; i--) {
              const c = this.data.find(item => item.id === res.data[i].id)
              if (!c) {
                const item = { ...res.data[i] }
                item.pickedName = item.picked === 1 ? "已接听" : "未接听";
                this.data.splice(0, 0, item)
              } else if (c.picked === 0 && res.data[i].picked === 1) {
                c.picked = 1
                c.pickedName = "已接听";
              } else if (this.user.userType == 6 && c.do1 === 0 && res.data[i].do1 === 1) {
                c.do1 = 1
              }
            }
            this.$forceUpdate()
          }
          this.forGetData()
        }).catch(() => { this.forGetData() })
      }, 5000)
    },
    do1 (index, id) {
      server.do1({ recordId: id }).then(data => {
        if (data === 1) {
          this.data[index].do1 = data
        }
      })
    },
    do2 (index, id, state) {
      server.do2({ recordId: id, state: state }).then(data => {
        if (data === 1) {
          this.data[index].do2 = state
        }
      })
    },
    loginout () {
      util.loginout()
    },
    join (roomId) {
      if (this.user.userID) {
        server.joinRoom({
          userId: this.user.userID,
          roomId: roomId
        }).then((res) => {
          if (res.data) {
            this.bCurrentPage = false;
            util.router('connect?roomID=' + roomId);
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.hospitalFrame {
  background: rgb(65, 73, 88);
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: center;
  padding: 3rem 6rem;
  color: #fff;
  overflow: scroll;
}
.grid-title {
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
}
.grid-title .van-cell {
  background: #fafafa;
}
.c-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
}
</style>